import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from '../../../../../ui/toast';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../i18n/constants/keys';
import { Button } from '../../../../../ui';
import { statusPatch } from '../../../../../utils/api_service/JobOpenings';
import { PatchProgress } from '../../../../../utils/types/JobOpenings';

type SubStage = {
  label: string;
  status: string;
};

type Stage = {
  label: string;
  status: string;
  subStages: SubStage[];
  currentSubStageIndex: number;
};

type ProgressTrackerProps = {
  title: string;
  globalState: string;
  stages: Stage[];
  onClose: () => void;
  show: boolean;
  setShow: (value: boolean | ((prev: boolean) => boolean)) => void;
  jobOpeningId: string;
  setStages: (
    value:
      | ((
          prevState: (
            | {
                currentSubStageIndex: number;
                subStages: (
                  | { label: string; status: string }
                  | { label: string; status: string }
                  | {
                      label: string;
                      status: string;
                    }
                )[];
                label: string;
                status: string;
              }
            | {
                currentSubStageIndex: number;
                subStages: (
                  | { label: string; status: string }
                  | { label: string; status: string }
                  | {
                      label: string;
                      status: string;
                    }
                  | { label: string; status: string }
                )[];
                label: string;
                status: string;
              }
            | {
                currentSubStageIndex: number;
                subStages: (
                  | { label: string; status: string }
                  | { label: string; status: string }
                  | {
                      label: string;
                      status: string;
                    }
                )[];
                label: string;
                status: string;
              }
            | {
                currentSubStageIndex: number;
                subStages: (
                  | { label: string; status: string }
                  | { label: string; status: string }
                  | {
                      label: string;
                      status: string;
                    }
                )[];
                label: string;
                status: string;
              }
            | {
                currentSubStageIndex: number;
                subStages: (
                  | { label: string; status: string }
                  | { label: string; status: string }
                  | {
                      label: string;
                      status: string;
                    }
                )[];
                label: string;
                status: string;
              }
            | {
                currentSubStageIndex: number;
                subStages: (
                  | { label: string; status: string }
                  | { label: string; status: string }
                  | {
                      label: string;
                      status: string;
                    }
                  | { label: string; status: string }
                )[];
                label: string;
                status: string;
              }
          )[]
        ) => (
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
              )[];
              label: string;
              status: string;
            }
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
                | { label: string; status: string }
              )[];
              label: string;
              status: string;
            }
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
              )[];
              label: string;
              status: string;
            }
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
              )[];
              label: string;
              status: string;
            }
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
              )[];
              label: string;
              status: string;
            }
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
                | { label: string; status: string }
              )[];
              label: string;
              status: string;
            }
        )[])
      | (
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
              )[];
              label: string;
              status: string;
            }
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
                | { label: string; status: string }
              )[];
              label: string;
              status: string;
            }
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
              )[];
              label: string;
              status: string;
            }
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
              )[];
              label: string;
              status: string;
            }
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
              )[];
              label: string;
              status: string;
            }
          | {
              currentSubStageIndex: number;
              subStages: (
                | { label: string; status: string }
                | { label: string; status: string }
                | {
                    label: string;
                    status: string;
                  }
                | { label: string; status: string }
              )[];
              label: string;
              status: string;
            }
        )[]
  ) => void;
};

const statusColors: Record<string, string> = {
  Completed: 'bg-emerald-500 text-white shadow-emerald-200',
  'In Progress': 'bg-blue-500 text-white shadow-blue-200',
  Inactive: 'bg-gray-400 text-gray-600 shadow-gray-200',
  Pending: 'bg-amber-500 text-white shadow-amber-200',
  Closed: 'bg-slate-600 text-white shadow-slate-200',
  'Decision in Progress': 'bg-indigo-500 text-white shadow-indigo-200',
  'Offer in Progress': 'bg-purple-500 text-white shadow-purple-200',
  'Offer Accepted': 'bg-emerald-600 text-white shadow-emerald-200',
  'No Suitable Candidate': 'bg-red-500 text-white shadow-red-200',
  'No Offers Accepted': 'bg-red-700 text-white shadow-red-200',
  'Job Request Withdrawn': 'bg-orange-500 text-white shadow-orange-200',
};

const statusBorderColors: Record<string, string> = {
  Completed: 'border-emerald-500',
  'In Progress': 'border-blue-500',
  Inactive: 'border-gray-400',
  Pending: 'border-amber-500',
  Closed: 'border-slate-600',
  'Decision in Progress': 'border-indigo-500',
  'Offer in Progress': 'border-purple-500',
  'Offer Accepted': 'border-emerald-600',
  'No Suitable Candidate': 'border-red-500',
  'No Offers Accepted': 'border-red-700',
  'Job Request Withdrawn': 'border-orange-500',
};

const ProgressTracker: React.FC<ProgressTrackerProps> = ({
  title,
  globalState,
  stages,
  onClose,
  show,
  setShow,
  jobOpeningId,
  setStages,
}) => {
  const { t } = useTranslation(NS.adminPages);
  const PT = ADMIN_PAGES_KEYS.jobOpenings.progressTracker;

  const STAGE_LABEL_KEYS: Record<string, string> = {
    'Job Description': PT.labels.jobDescription,
    'Job Post': PT.labels.jobPost,
    'Shortlisting': PT.labels.shortlisting,
    'Interviews': PT.labels.interviews,
    'Decision Making': PT.labels.decisionMaking,
    'Closed': PT.labels.closed,
  };

  const STATUS_KEYS: Record<string, string> = {
    'Inactive': PT.statuses.inactive,
    'Pending': PT.statuses.pending,
    'In Progress': PT.statuses.inProgress,
    'Completed': PT.statuses.completed,
    'Decision in Progress': PT.statuses.decisionInProgress,
    'Offer in Progress': PT.statuses.offerInProgress,
    'Offer Accepted': PT.statuses.offerAccepted,
    'No Suitable Candidate': PT.statuses.noSuitableCandidate,
    'No Offers Accepted': PT.statuses.noOffersAccepted,
    'Job Request Withdrawn': PT.statuses.jobRequestWithdrawn,
  };

  const [openStageIndex, setOpenStageIndex] = useState<number | null>(null);

  // Calculate overall progress
  const overallProgress = useMemo(() => {
    const completedStages = stages.filter(
      (stage) => stage.status === 'Completed',
    ).length;
    return (completedStages / stages.length) * 100;
  }, [stages]);

  const toTitleCase = (str: string) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Map decision making statuses to match backend enum values
  const mapDecisionMakingStatus = (status: string): string => {
    const statusMappings: Record<string, string> = {
      'In Progress': 'Decision in Progress',
      'Decision in Progress': 'Decision in Progress',
      'Offer in Progress': 'Offer in Progress',
      Inactive: 'Inactive',
      Completed: 'Completed',
    };

    return statusMappings[status] || status;
  };

  // Map shortlisting statuses to match backend enum values
  const mapShortlistingStatus = (status: string): string => {
    const statusMappings: Record<string, string> = {
      Pending: 'Inactive',
      'In Progress': 'In Progress',
      Inactive: 'Inactive',
      Closed: 'Closed',
      Completed: 'Completed',
    };

    return statusMappings[status] || status;
  };

  // Map job post statuses to match backend enum values
  const mapJobPostStatus = (status: string): string => {
    const statusMappings: Record<string, string> = {
      Pending: 'Inactive',
      'In Progress': 'In Progress',
      Inactive: 'Inactive',
      Published: 'Published',
      Completed: 'Completed',
    };

    return statusMappings[status] || status;
  };

  // Map general statuses for other fields
  const mapGeneralStatus = (status: string): string => {
    const statusMappings: Record<string, string> = {
      Pending: 'Inactive',
      'In Progress': 'In Progress',
      Inactive: 'Inactive',
      Completed: 'Completed',
    };

    return statusMappings[status] || status;
  };

  const clickableStages = [
    'Shortlisting',
    'Decision Making',
    'Closed',
    'Job Post',
    'Interviews',
  ];

  const updateStage = async (
    stageClicked: string,
    newStage: string,
    index: number,
  ) => {
    const hasShortlisting = stages.some(
      (stage) => stage.label === 'Shortlisting',
    );
    const offset = hasShortlisting ? -1 : 0;
    // Only update the specific stage that was clicked

    const statesObject: PatchProgress = {
      jobDescription: mapGeneralStatus(toTitleCase(stages[0].status)),
      jobPost:
        newStage === 'Job Post'
          ? mapJobPostStatus(toTitleCase(stageClicked))
          : mapJobPostStatus(toTitleCase(stages[1].status)),
      shortlisting:
        newStage === 'Shortlisting'
          ? mapShortlistingStatus(toTitleCase(stageClicked))
          : mapShortlistingStatus(toTitleCase(stages[2 + offset].status)),
      interviews:
        newStage === 'Interviews'
          ? mapGeneralStatus(toTitleCase(stageClicked))
          : mapGeneralStatus(toTitleCase(stages[3 + offset].status)),
      decisionMaking:
        newStage === 'Decision Making'
          ? mapDecisionMakingStatus(stageClicked)
          : mapDecisionMakingStatus(stages[4 + offset].status),
      closed:
        newStage === 'Closed'
          ? toTitleCase(stageClicked)
          : toTitleCase(stages[5 + offset].status),
    };

    switch (newStage) {
      case 'Job Description':
        statesObject.jobDescription = mapGeneralStatus(
          toTitleCase(stageClicked),
        );
        break;
      case 'Job Post':
        statesObject.jobPost = mapJobPostStatus(toTitleCase(stageClicked));
        break;
      case 'Shortlisting':
        statesObject.shortlisting = mapShortlistingStatus(
          toTitleCase(stageClicked),
        );
        break;
      case 'Interviews':
        statesObject.interviews = mapGeneralStatus(toTitleCase(stageClicked));
        break;
      case 'Decision Making':
        statesObject.decisionMaking = mapDecisionMakingStatus(stageClicked);
        break;
      case 'Closed':
        statesObject.closed = toTitleCase(stageClicked);
        break;
    }

    setStages((prevStages: any[]) =>
      prevStages.map((stage) => {
        if (stage.label === newStage) {
          const newCurrentSubStageIndex = stage.subStages.findIndex(
            (sub: any) => sub.status === stageClicked,
          );

          return {
            ...stage,
            status: stageClicked,
            currentSubStageIndex:
              newCurrentSubStageIndex !== -1
                ? newCurrentSubStageIndex
                : stage.currentSubStageIndex,
          };
        }
        return stage;
      }),
    );

    try {
      await statusPatch(jobOpeningId, statesObject as PatchProgress);

      // Show context-aware success messages
      if (newStage === 'Closed' && stageClicked === 'Offer Accepted') {
        toast.success(
          'Success! Job opening has been moved to closed - Offer Accepted',
          {
            position: 'bottom-center',
            autoClose: 4000,
          },
        );
      } else if (
        newStage === 'Decision Making' &&
        stageClicked === 'Decision in Progress'
      ) {
        toast.success('Status updated to Decision in Progress', {
          position: 'bottom-center',
        });
      } else if (
        newStage === 'Decision Making' &&
        stageClicked === 'Offer in Progress'
      ) {
        toast.success('Status updated to Offer in Progress', {
          position: 'bottom-center',
        });
      } else if (stageClicked === 'Completed') {
        toast.success(`${newStage} completed successfully!`, {
          position: 'bottom-center',
        });
      } else {
        toast.success(`Status updated to ${stageClicked}`, {
          position: 'bottom-center',
        });
      }
    } catch (error) {
      toast.error('Failed to change state', { position: 'bottom-center' });
    }
  };
  const handleSubStageClick = (stageIndex: number, subIndex: number) => {
    if (stages[stageIndex].label !== 'Closed') return;

    const updatedStages = [...stages];
    updatedStages[stageIndex].currentSubStageIndex = subIndex;
    // setStages(updatedStages);
  };

  return (
    <div className='relative bg-gray-50 rounded-lg border border-gray-200 shadow-sm p-2'>
      <div
          className='flex flex-col gap-2 lg:flex-row lg:items-center'
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setOpenStageIndex(null);
            }
          }}
      >
        { /* Global State Badge */ }
        <div className='flex min-h-9 flex-row items-center justify-between gap-2 px-2 py-1 bg-white border border-gray-200 rounded-md lg:min-w-[85px] lg:flex-col lg:items-start lg:justify-center lg:gap-0'>
          <span className='text-[8px] font-bold text-gray-400 uppercase tracking-widest leading-none mb-1'>
            { t(ADMIN_PAGES_KEYS.jobOpenings.ui.stateLabel) }
          </span>
          <span className='text-[10px] font-bold text-blue-700 leading-none truncate'>
            { globalState }
          </span>
        </div>

        { /* Stages */ }
        <div className='flex flex-1 gap-1 overflow-x-auto pb-1 lg:flex-wrap lg:overflow-visible lg:pb-0'>
          { stages.map((stage, index) => {
            const isOpen = openStageIndex === index;
            const clickable = clickableStages.includes(stage.label);
            const isCompleted =
              stage.status === 'Completed' || stage.status === 'Offer Accepted';
            const isInProgress = stage.status === 'In Progress';

            return (
              <div key={index} className='relative min-w-[132px] flex-1 lg:min-w-[90px]'>
                { /* Stage Card */ }
                <div
                    className={`relative flex min-h-10 items-center justify-between gap-2 p-1.5 px-2 border rounded-md cursor-pointer transition-all duration-200 hover:shadow-sm lg:h-8 lg:min-h-0 ${
                      statusBorderColors[stage.status]
                    } ${isOpen ? 'shadow-sm ring-2 ring-blue-100' : ''} ${
                      isCompleted
                        ? 'bg-emerald-50'
                        : isInProgress
                          ? 'bg-blue-50'
                          : 'bg-gray-50'
                    }`}
                    onClick={() => setOpenStageIndex(isOpen ? null : index)}
                >
                  <div className='flex flex-col justify-center min-w-0 flex-1 '>
                    <h3 className='font-bold text-gray-800 text-[10px] leading-tight truncate mb-0.5'>
                      { t(STAGE_LABEL_KEYS[stage.label] ?? stage.label) }
                    </h3>
                    <div className='flex items-center gap-1 shrink-0'>
                      <div
                          className={`w-1.5 h-1.5 rounded-full ${
                            statusColors[stage.status].split(' ')[0]
                          }`}
                      />
                      <span className='text-[9px] text-gray-500 font-semibold whitespace-nowrap leading-none'>
                        { t(STATUS_KEYS[stage.status] ?? stage.status) }
                      </span>
                    </div>
                  </div>

                  { /* Click indicator for expandable stages */ }
                  { stage.subStages.length > 0 && (
                    <div
                        className={`transition-transform duration-200 ${
                          isOpen ? 'rotate-180' : ''
                        }`}
                    >
                      <svg
                          className='w-2.5 h-2.5 text-gray-400'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                      >
                        <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={3}
                            d='M19 9l-7 7-7-7'
                        />
                      </svg>
                    </div>
                  ) }
                </div>

                { /* Dropdown Sub-stages */ }
                { isOpen && (
                  <div className='absolute top-full left-0 w-full z-[9999] mt-1 bg-white border-2 border-blue-200 rounded-lg shadow-2xl max-h-48 overflow-y-auto'>
                    { stage.subStages.map((sub, subIndex) => {
                      const isCurrent = stage.currentSubStageIndex === subIndex;
                      const isSubCompleted =
                        subIndex < stage.currentSubStageIndex;

                      return (
                        <div
                            key={subIndex}
                            className={`flex items-center justify-between p-2 text-xs border-b border-gray-100 last:border-b-0 transition-all duration-200 ${
                              isCurrent
                                ? 'bg-blue-50 text-blue-800'
                                : isSubCompleted
                                  ? 'bg-emerald-50 text-emerald-800'
                                  : 'bg-gray-50 text-gray-600 opacity-70'
                            } ${
                              clickable ? 'cursor-pointer hover:bg-gray-100' : ''
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (clickable) {
                                updateStage(
                                  stages[index].subStages[subIndex].status,
                                  stage.label,
                                  subIndex,
                                );
                              }
                            }}
                        >
                          <div className='flex items-center gap-1.5'>
                            <span className='text-xs font-medium truncate'>
                              { t(STATUS_KEYS[sub.label] ?? sub.label) }
                            </span>
                          </div>

                          <div
                              className={`w-1.5 h-1.5 rounded-full ${
                                statusColors[sub.status].split(' ')[0]
                              }`}
                          />
                        </div>
                      );
                    }) }
                  </div>
                ) }
              </div>
            );
          }) }
        </div>
      </div>

      { /* Bottom Progress Bar */ }
      <div className='absolute bottom-0 left-0 right-0'>
        <div className='h-0.5 bg-gray-200'>
          <div
              className='h-full bg-blue-500 transition-all duration-500'
              style={{ width: `${overallProgress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressTracker;
